import React from 'react';
import AppModal from "../../core/components/app-modal";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import useModalWithData from "@common/hooks/use-modal-with-data";
import {useModalAnimation} from "../../core/animations";
import AppButton from "@common/components/app-button";
import {animated} from "@react-spring/web";
import {useSpecialistApi} from "../../core/hooks/use-specialist-api";
import {UniversalClickHandler} from "@common/models/types/universal-click-handler.type";

export interface SpecialistDeleteModalData {
    id: string;
    fullName: string;
    onSuccess?: UniversalClickHandler;
}

const SpecialistDeleteConfirmModal: React.FC = () => {
    const {
        data,
        hideModal,
        isOpenModal
    } = useModalWithData<SpecialistDeleteModalData>(ModalIds.SPECIALIST_DELETE_CONFIRM);
    const {springProps, closeModal} = useModalAnimation(!!isOpenModal(), 'medium');
    const {deleteSpecialist} = useSpecialistApi();

    const handleCancel = () => closeModal(() => hideModal());
    const handleConfirm = async (): Promise<void> => {
        try {
            await deleteSpecialist(data?.id!);
            data?.onSuccess && data?.onSuccess();
            handleCancel();
            window.dispatchEvent(new CustomEvent('specialists:refresh'));
        } catch (e) {
            console.error('Error deleting specialist', e);
        }
    };

    return (
        <AppModal
            id={ModalIds.SPECIALIST_DELETE_CONFIRM}
            key={ModalIds.SPECIALIST_DELETE_CONFIRM}
            zIndex={50}
            forceFixed={true}
        >
            <animated.div
                style={springProps}
                className="h-full w-full flex flex-col bg-[#F9FAFB] rounded-2xl"
            >
                <div className="flex items-center justify-between pl-8 pr-4 py-3 h-[72px] max-h-[72px]">
                    <h2 className="text-lg font-semibold text-on-surface leading-[22px]">Usunąć specjalistę?</h2>
                </div>
                <div className="px-8 py-4 text-on-surface/90">
                    Czy na pewno chcesz usunąć profil “<span className="font-semibold">{data?.fullName}</span>” z listy
                    specjalistów?
                </div>
                <div className="flex items-center flex-wrap md:flex-nowrap justify-end gap-2 py-3 md:py-0 md:h-[72px] md:min-h-[72px] rounded-b-2xl border-t border-outline-mild px-8">
                    <AppButton
                        onClick={handleCancel}
                        className="bg-transparent w-full md:w-fit max-h-[40px] h-[40px] !px-6 !pt-2 border-[2px] !border-on-surface font-semibold text-base !rounded-full hover:bg-on-surface/5"
                        label="Anuluj"
                    />
                    <AppButton
                        onClick={handleConfirm}
                        className="bg-error w-full md:w-fit max-h-[40px] h-[40px] !px-6 !pt-2 text-on-primary font-semibold text-base !rounded-full hover:bg-error/80"
                        label="Usuń specjalistę"
                    />
                </div>
            </animated.div>
        </AppModal>
    );
};

export default SpecialistDeleteConfirmModal;

